import { api } from './client.js';

export const getJobFavoriteIds = () => api.get('/company/job-favorites/ids');

export const getFavoriteJobs = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set('page', String(params.page));
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.search) qs.set('search', params.search);
  if (params.sort) qs.set('sort', params.sort);
  if (params.source) qs.set('source', params.source);
  if (params.jobType) qs.set('jobType', params.jobType);
  if (params.location) qs.set('location', params.location);
  if (params.experienceLevel) qs.set('experienceLevel', params.experienceLevel);
  if (params.skill) qs.set('skill', params.skill);
  if (params.skills) qs.set('skills', params.skills);
  if (params.industryIds) qs.set('industryIds', params.industryIds);
  if (params.dateRange) qs.set('dateRange', params.dateRange);
  if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
  if (params.dateTo) qs.set('dateTo', params.dateTo);
  if (params.jobMode) qs.set('jobMode', params.jobMode);
  if (params.salaryPreset) qs.set('salaryPreset', params.salaryPreset);
  if (params.salaryMin != null && params.salaryMin !== '') qs.set('salaryMin', String(params.salaryMin));
  if (params.salaryMax != null && params.salaryMax !== '') qs.set('salaryMax', String(params.salaryMax));
  const query = qs.toString();
  return api.get(`/company/job-favorites${query ? `?${query}` : ''}`);
};

export const addJobFavorite = (jobId) => api.post('/company/job-favorites', { jobId });

export const removeJobFavorite = (jobId) => api.delete(`/company/job-favorites/${jobId}`);
